@if (isUserLoggedIn) {
  <section id="off-canvas">
    <nav class="main-navholder" role="navigation">
      <div class="nav-scroll-holder">
        <ul class="nav nav-primary">
          <!-- L. -->
          <li class="home">
            <a routerLink="/" (click)="clickMenuItem($event)">
              <span><img src="/images/BB-L-logo-white.svg" /></span>
              <span><img src="/images/BB-Link-logo.svg" /></span>
            </a>
          </li>
          @for (menuItem of menuItems; track menuItem) {
            <li *bizPermissionRequired="menuItem.permission;type:menuItem.permissionType" routerLinkActive="active" class="no-select"
              routerLink="/{{menuItem.link}}">
              <a (click)="clickMenuItem($event, menuItem)" (dblclick)="doubleClickMenuItem($event, menuItem)">
                <span class="icon-holder">
                  <ep-svg-icon icon="menu-{{menuItem.name}}"></ep-svg-icon>
                </span>
                <span class="icon-caption">{{menuItem.caption}}</span>
              </a>
              <ul id="ul{{menuItem.name}}" style="display:none">
                @for (childGroup of menuItem.groups; track childGroup) {
                  <li class="header">{{childGroup.caption}}</li>
                  @for (childItem of childGroup.items; track childItem) {
                    @if (childItem.name === '-') {
                      <li *bizPermissionRequired="childItem.permission;type:childItem.permissionType" role="separator" class="divider"></li>
                    }
                    @if (childItem.name !== '-') {
                      <li *bizPermissionRequired="childItem.permission;type:childItem.permissionType">
                        <div [class.menu-list]="childItem.tag && (childItem.tag.savedTrackingSearch || childItem.tag.savedPartnerFavorite)">
                          @if (childItem.tag && childItem.tag.savedTrackingSearch) {
                            <button class="btn btn-link np" title="Delete"
                              (click)="removeTrackingSearch(childItem.tag.savedTrackingSearch)">
                              <ep-svg-icon icon="circle-cross"></ep-svg-icon>
                            </button>
                          }
                          @if (childItem.tag && childItem.tag.savedPartnerFavorite) {
                            <button class="btn btn-link np" title="Delete"
                              (click)="removePartnerFavorite(childItem.tag.savedPartnerFavorite)">
                              <ep-svg-icon icon="circle-cross"></ep-svg-icon>
                            </button>
                          }
                          @if (childItem.link) {
                            @if (childItem.param) {
                              <a [routerLink]="['/'+childItem.link, childItem.param]"
                              (click)="clickMenuChildItem($event, childItem)">{{childItem.name}}</a>
                            }
                            @if (!childItem.param) {
                              <a [routerLink]="['/'+childItem.link]"
                              (click)="clickMenuChildItem($event, childItem)">{{childItem.name}}</a>
                            }
                          }
                          @if (!childItem.link) {
                            <a
                            (click)="clickMenuChildItem($event, childItem)">{{childItem.name}}</a>
                          }
                        </div>
                      </li>
                    }
                  }
                }
              </ul>
            </li>
          }
        </ul>
      </div>
    </nav>
  </section>
}
